export default __webpack_public_path__ + "static/media/logo_nobg_black.a334def7.png";